import { contextSpecForOperation } from '@foodlista/operations'

/**
 * Version-gated read of a persisted context, used by the paths that only need
 * identity fields: scope matching and completion effects. A projection version
 * this client does not understand is never read, so a v2 envelope that reused a
 * key with new semantics cannot be matched as if it were v1.
 *
 * Deliberately does not run the full schema: matching must not break because an
 * unrelated field of the same version is missing or extra. Presentation, which
 * renders context values, parses the schema instead (see `readContext` in
 * `presentation/presenters.ts`).
 *
 * Returns `null` for an envelope with no context (created before the column),
 * an unknown operation type, or a version mismatch.
 */
export function readOperationContext(item: {
  type: string
  contextVersion: number | null
  context: unknown
}): Record<string, unknown> | null {
  const spec = contextSpecForOperation(item.type)
  if (!spec || item.contextVersion !== spec.version) {
    return null
  }

  if (typeof item.context !== 'object' || item.context === null) {
    return null
  }

  return item.context as Record<string, unknown>
}
